
export default function Rollback({ clearEditing }) {
    return async ({ keys }) => {
        console.log("Clear Editing")
        clearEditing(keys)
    }
}